import { createApp } from 'vue'
import '../node_modules/flowbite-vue/dist/index.css'
import App from './App.vue'
import './assets/tailwind.css'

createApp(App).mount('#app')
